import { syncFavoritesApi } from '@/entities/favorites';

import { useFavoriteGuestStore } from '../model/favoriteGuestStore';

export async function mergeGuestFavoritesAfterAuth(): Promise<void> {
  const ids = useFavoriteGuestStore.getState().entries.map((e) => e.id);
  if (!ids.length) {
    return;
  }

  try {
    await syncFavoritesApi(ids);
  } catch {
    return;
  }

  useFavoriteGuestStore.getState().clear();
}
